import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";

export const warrantySettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Registration", {
          context: "merchant settings label for warranty registration",
        });
      },
      permission: settingsPagePermission("warranties/registration"),
    },
    path: "registrations",
    lazy: async () => {
      const { WarrantyRegistrationSettings } =
        await import("../../../../setting/registration-settings");
      return { element: <WarrantyRegistrationSettings /> };
    },
  },
  {
    handle: {
      get breadcrumb() {
        return t("Registration rewards", {
          context: "merchant settings label for warranty registration rewards",
        });
      },
      permission: settingsPagePermission("warranties/registration-rewards"),
    },
    path: "registration-rewards",
    lazy: async () => {
      const { RegistrationRewards } =
        await import("../../../../setting/registration-rewards");
      return { element: <RegistrationRewards /> };
    },
  },
];
